// @flow
import React from 'react';
import cx from 'classnames';

import Coin from 'components/Coin.jsx';
import EventTracking from 'lib/EventTracking';
import GroupMemberFamily from 'groups/components/GroupMemberFamily.jsx';
import MediaObject from 'components/MediaObject.jsx';
import Text from 'components/Text.jsx';
import TextWithGlyph from 'components/TextWithGlyph.jsx';
import UserAvatar from 'users/components/UserAvatar.jsx';

type Props = {
  student: *,
  orgUuid: string,
  disableStudent?: boolean,
  disableParent?: boolean,
  onParentAdd?: () => void,
};

function UnmatchedAvatar() {
  return (
    <Coin size="xxxlarge" border="koala">
      <Text size="xxsmall" color="eclipse">
        ?
      </Text>
    </Coin>
  );
}

export default class TargetByStudentIdSelectPageStudentRow extends React.Component<Props, *> {
  render() {
    const { student, disableStudent, disableParent, onParentAdd, orgUuid } = this.props;
    const { user } = student;

    if (!user) {
      return (
        <tr key={student.studentId} className="TargetByStudentIdSelectPage-table-row--unmatched">
          <td>
            <MediaObject center gutter="xsmall">
              <UnmatchedAvatar />
              <Text color="thunder">Unidentified</Text>
            </MediaObject>
          </td>
          <td>
            <TextWithGlyph
              weight="semibold"
              glyph="caution"
              glyphSize="medium"
              glyphColor="sunrise"
              truncate>
              {student.studentId}
            </TextWithGlyph>
          </td>
          <td>
            <UnmatchedAvatar />
          </td>
        </tr>
      );
    }

    return (
      <tr key={user.uuid}>
        <td className={cx(disableStudent && 'TargetByStudentIdSelectPage-table-cell--disabled')}>
          <MediaObject center gutter="xsmall">
            <UserAvatar user={user} size="medium" />
            <span>{user.name}</span>
          </MediaObject>
        </td>
        <td className={cx(disableStudent && 'TargetByStudentIdSelectPage-table-cell--disabled')}>
          <Text truncate>{student.studentId}</Text>
        </td>
        <td className={cx(disableParent && 'TargetByStudentIdSelectPage-table-cell--disabled')}>
          <GroupMemberFamily
            userId={user.id}
            userUuid={user.uuid}
            directAddOptions={{ orgUuid }}
            familySummary={user.familySummary || { parents: [], children: [] }}
            canAddChild={false}
            canAddParent
            refetchMemberSummary={onParentAdd}
            staticProfilePicture
            addFamilyModalEventPrefix="announcements.target_by_student_id"
            addButtonOnClick={() =>
              EventTracking.trackKey(
                'announcements.target_by_student_id.list_of_uploaded_users.add_parent.click'
              )
            }
          />
        </td>
      </tr>
    );
  }
}
